/**
 * Guest explore flow — persisted plan + post-auth navigation handoff.
 */
import AsyncStorage from '@react-native-async-storage/async-storage';

const GUEST_PLAN_KEY = 'guestExplorePendingPlan';

export async function setGuestExplorePlan(plan: Record<string, unknown>): Promise<void> {
  try {
    await AsyncStorage.setItem(GUEST_PLAN_KEY, JSON.stringify(plan));
  } catch {
    // ignore
  }
}

export async function getGuestExplorePlan(): Promise<Record<string, unknown> | null> {
  try {
    const raw = await AsyncStorage.getItem(GUEST_PLAN_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    return typeof parsed === 'object' && parsed != null ? (parsed as Record<string, unknown>) : null;
  } catch {
    return null;
  }
}

export async function clearGuestExplorePlan(): Promise<void> {
  try {
    await AsyncStorage.removeItem(GUEST_PLAN_KEY);
  } catch {
    // ignore
  }
}
